import {findSuggestionMatch as findSuggestionMatchOriginal} from '@tiptap/suggestion';

const QUERY_LIMIT = 64;
const escapeSymbols = new Set(['@', ' ']);

export const findSuggestionMatch: typeof findSuggestionMatchOriginal = (config) => {
    const suggestionMatch = findSuggestionMatchOriginal(config);
    if (!suggestionMatch) {
        return null;
    }

    if (suggestionMatch.query.length > QUERY_LIMIT) {
        return null;
    }

    const firstSymbol = suggestionMatch.query[0];
    if (!firstSymbol) {
        return suggestionMatch;
    }

    if (escapeSymbols.has(firstSymbol)) {
        return null;
    }

    return suggestionMatch;
};
